"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.sms = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
const app_1 = require("../app");
// eslint-disable-next-line @typescript-eslint/no-namespace
var sms;
(function (sms) {
    class VerifyNumberRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], VerifyNumberRequest.prototype, "phoneNumber", void 0);
    __decorate([
        toccata_1.validator.IsISO31661Alpha2(),
        toccata_1.validator.IsOptional()
    ], VerifyNumberRequest.prototype, "countryCode", void 0);
    sms.VerifyNumberRequest = VerifyNumberRequest;
    class VerifyNumberResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsBoolean()
    ], VerifyNumberResponse.prototype, "valid", void 0);
    __decorate([
        toccata_1.validator.ValidateIf(o => o.valid),
        toccata_1.validator.IsString()
    ], VerifyNumberResponse.prototype, "phoneNumber", void 0);
    sms.VerifyNumberResponse = VerifyNumberResponse;
})(sms = exports.sms || (exports.sms = {}));
function init(firebaseApp) {
    const functions = firebaseApp
        ? firebaseApp.functions()
        : app_1.app.firebase.functions();
    // TODO: Actually Implement
    return {
        verifyNumber: (0, toccata_1.createFunction)(functions, 'sms-verifyNumber', sms.VerifyNumberRequest, sms.VerifyNumberResponse),
    };
}
exports.init = init;
//# sourceMappingURL=sms.js.map